import icon from '../../Icons/icon_brightness_38.png'
import {motion} from 'framer-motion'
import {baseurl} from '../../services/services'


import {useSelector} from 'react-redux'
import {concertSelector} from '../../Slices/ticketslice'
import {ConcertCard} from '../index'
import {LinearProgress} from "@mui/material";


const Midbox = () => {

    const status=useSelector(state => state.ticket.status);
    const dataNeeded=    [
        {
            concerts: {
                id: 24,
                title: 'کنسرت مجید رضوی',
                city_id: 1,
                remain: 1713558599,
                img: 'images/concert661e40143a158.png',
                singer_id: 2,
                location_id: 1,
                date: 1713558599,
                date_text: 'جمعه 31 فروردین',
                active: 1,
                type: 1
            },
            singers: {
                id: 2,
                name: 'رضا صادقی',
                singer_type: 1
            },
            cities: {
                id: 1,
                name: 'ارومیه'
            },
            locations_view: {
                id: 1,
                name: 'وحدت',
                lat: '27.55678812041777',
                lng: '48.49509674900293',
                city_id: 11,
                count: 5
            }
        },
        {
            concerts: {
                id: 11,
                title: 'تئاتر محمدرضا بند',
                city_id: 1,
                remain: 1705239547,
                img: 'images/4.png',
                singer_id: 9,
                location_id: 1,
                date: 1704893947,
                date_text: 'چهارشنبه 20 دی',
                active: 1,
                type: 3
            },
            singers: {
                id: 9,
                name: 'سیروان خسروی',
                singer_type: 1
            },
            cities: {
                id: 1,
                name: 'ارومیه'
            },
            locations_view: {
                id: 1,
                name: 'وحدت',
                lat: '27.55678812041777',
                lng: '48.49509674900293',
                city_id: 11,
                count: 5
            }
        },
        {
            concerts: {
                id: 10,
                title: 'همایش پر',
                city_id: 1,
                remain: 1705239547,
                img: 'images/4.png',
                singer_id: 8,
                location_id: 1,
                date: 1705239547,
                date_text: 'چهارشنبه 20 دی',
                active: 1,
                type: 2
            },
            singers: {
                id: 8,
                name: 'احسان خواجه امیری',
                singer_type: 1
            },
            cities: {
                id: 1,
                name: 'ارومیه'
            },
            locations_view: {
                id: 1,
                name: 'وحدت',
                lat: '27.55678812041777',
                lng: '48.49509674900293',
                city_id: 11,
                count: 5
            }
        },
        {
            concerts: {
                id: 9,
                title: 'همایش خالی',
                city_id: 1,
                remain: 1705239547,
                img: 'images/4.png',
                singer_id: 7,
                location_id: 1,
                date: 1705239547,
                date_text: 'چهارشنبه 20 دی',
                active: 1,
                type: 2
            },
            singers: {
                id: 7,
                name: 'محسن ابراهیم زاده',
                singer_type: 1
            },
            cities: {
                id: 1,
                name: 'ارومیه'
            },
            locations_view: {
                id: 1,
                name: 'وحدت',
                lat: '27.55678812041777',
                lng: '48.49509674900293',
                city_id: 11,
                count: 5
            }
        },
        {
            concerts: {
                id: 8,
                title: 'کنسرت تست',
                city_id: 11,
                remain: 1705264199,
                img: 'images/concert661fb63c50419.png',
                singer_id: 2,
                location_id: 1,
                date: 1705264199,
                date_text: 'یکشنبه 24 دی',
                active: 1,
                type: 1
            },
            singers: {
                id: 2,
                name: 'رضا صادقی',
                singer_type: 1
            },
            cities: {
                id: 11,
                name: 'شیراز'
            },
            locations_view: {
                id: 1,
                name: 'وحدت',
                lat: '27.55678812041777',
                lng: '48.49509674900293',
                city_id: 11,
                count: 5
            }
        },
        {
            concerts: {
                id: 7,
                title: 'تئاتر آخرین شام',
                city_id: 11,
                remain: Date.now(),
                img: 'images/3.png',
                singer_id: 3,
                location_id: 1,
                date: 1714336199,
                date_text: 'یکشنبه 09 اردیبهشت',
                active: 2,
                type: 1
            },
            singers: {
                id: 3,
                name: 'سامان جلیلی',
                singer_type: 1
            },
            cities: {
                id: 11,
                name: 'شیراز'
            },
            locations_view: {
                id: 1,
                name: 'وحدت',
                lat: '27.55678812041777',
                lng: '48.49509674900293',
                city_id: 11,
                count: 5
            }
        },
        {
            concerts: {
                id: 6,
                title: 'همایش محسن خیرخواه',
                city_id: 1,
                remain: 1705239547,
                img: 'images/2.png',
                singer_id: 2,
                location_id: 1,
                date: 1705239547,
                date_text: 'چهارشنبه 20 دی',
                active: 1,
                type: 1
            },
            singers: {
                id: 2,
                name: 'رضا صادقی',
                singer_type: 1
            },
            cities: {
                id: 1,
                name: 'ارومیه'
            },
            locations_view: {
                id: 1,
                name: 'وحدت',
                lat: '27.55678812041777',
                lng: '48.49509674900293',
                city_id: 11,
                count: 5
            }
        },
        {
            concerts: {
                id: 5,
                title: 'کنسرت مجید رضوی',
                city_id: 1,
                remain: 1704893947,
                img: 'images/1.png',
                singer_id: 1,
                location_id: 1,
                date: 1704893947,
                date_text: 'چهارشنبه 20 دی',
                active: 0,
                type: 1
            },
            singers: {
                id: 1,
                name: 'مهدی احمد وند',
                singer_type: 1
            },
            cities: {
                id: 1,
                name: 'ارومیه'
            },
            locations_view: {
                id: 1,
                name: 'وحدت',
                lat: '27.55678812041777',
                lng: '48.49509674900293',
                city_id: 11,
                count: 5
            }
        }
    ]



    // changing the city shown based on the city selected by the user
    const choice = JSON.parse(localStorage.getItem('city'));



    let content
    if (dataNeeded) {



        if (dataNeeded.length > 0) {

            content = dataNeeded.map((item, index) => (


                <ConcertCard key={index} image={`${baseurl}/${item.concerts.img}`} id={item.concerts.id}
                             singer={item.concerts.title}
                             time={item.concerts.date_text}
                             location={item.locations_view.name} statusCode={item.concerts.active}
                             ts={item.concerts.date} remain={item.concerts.remain} city={item.cities.name}/>

            ))
        } else {
            content = <div className='column is-12'>
                <p className='yekan has-text-centered is-size-4-desktop'>
                    در شهر انتخاب شده برنامه ای جهت نمایش وجود ندارد.
                </p>
            </div>
        }


    } else {
        content = <div className='column is-12'>
            <LinearProgress variant='indeterminate' color='info'/>
        </div>
    }

    return (
        <>
            <section>


                <div className='columns mx-0  is-multiline navpadend150 navpadstart150 my-6 '>
                    <div className='column is-12'>
                        <motion.img src={icon} alt="icon" style={{transform: 'translateY(1rem) translateX(1.6rem)'}}
                                    initial={{opacity: 0}} animate={{opacity: 1, x: [200, 0]}}
                                    transition={{duration: 0.8}}/>
                        <h2 className='is-size-4-mobile is-size-4-desktop pinar has-text-weight-bold mb-6'>

                             برنامه های پیش رو در
                            {
                                choice ?
                                    <span className='mx-1'>


                                        {choice.name}


                                    </span>

                                    : <span className='mx-1'>
                                    کل شهر ها
                                    </span>
                            }
                        </h2>

                        <div className='columns'>
                            <div className='column  is-12 '>
                                <motion.div className='columns is-flex is-multiline' initial='hidden' animate='visible'
                                            variants={{
                                                visible: {
                                                    opacity: 1,
                                                    scale: 1,
                                                    transition: {
                                                        delayChildren: 0.2,
                                                        staggerChildren: 0.3,
                                                        duration: 0.963

                                                    },
                                                },
                                                hidden: {
                                                    opacity: 1, scale: 0

                                                },
                                            }}>


                                    {content}


                                </motion.div>


                            </div>
                        </div>


                    </div>


                </div>
            </section>

        </>
    )
}
export default Midbox